module.exports = __webpack_public_path__ + "static/media/feature-graphic.e83baa7a.png";